export default {
  // title
  titleMarketUpdates: "Market Updates",
  titleTrendingCompanies: "Trending Companies",
  titleInvite: "Invite & earn rewards",
  titleOnboarding: "Onboarding kit",

  exportingLeadsToACSV:
    "Exporting leads to a CSV will use {count} credit. | Exporting leads to a CSV will use {count} credits.",

  // trending companies

  // invite
  forReferrals: "For referrals:",
  inviteBtn: "Invite",
  copyLink: "Copy link",
  shareYourReferralLink:
    "Share your referral link or enter an email to invite others. Earn rewards when they join!",
  forTeamInvites: "For team invites (to earn credits):",
  assignTeamInvites: "Assign team invites",
  lookingToGrowYourTeam:
    "Looking to grow your team? Assign invites and start earning credits every time someone joins!",
  addMultipleAddresses: "Add multiple addresses separated by commas",
  greatProgress:
    "Great progress! Keep inviting to unlock the full {count} credits.",
  startInviting: "Start inviting and earn up to {count} credits!",
  allSet: "All set! You've earned your {count} credits—thanks for inviting!",

  // custom insight
  addYourOwnCustomInsights: "Add your own custom insights",
  companyKeyMilestones: "Company’s key milestones",
  listMajorCompetitors: "List major competitors in the same industry",
  analyzeMarketPresence: "Analyze the company’s market presence",
  poweredByAi: "Powered by Ai",

  // onboarding kit
  grantedUponCompletion: "{count} Granted upon completion",
  granted_complete: "{count} Credits bonus granted!",

  // ai
  meetRonnaAi: "Meet RonnaAi - Your Smart Business Assistant",
  askAnything: "Ask anything...",
  askQuestionsExploreStrategies:
    "Ask questions, explore strategies, or get instant insights tailored for you.",
  limitedView: "Limited View",
  viewFullCompanyDetails: "View full company details",
  recentThreads: "Recent threads",
  recentlyViewed: "Recently viewed",
  companyAndWebsite: "Company / Website",
  noResultsAskAi: "No results? Ask RonnaAI for related information",
  allSearchResultsFor: "All search results for {count}",
  searchForAnything: "Search for anything",
  pressEnter: "Press ENTER",
  askRonnaAI: "Ask RonnaAI:",
  clickToChatWithRonnaAI: "Click to chat with RonnaAI and get more details",
  useRonnaAIToExploreBusinessDirectories:
    "Use RonnaAI to explore business directories, insights, and more, instantly.",
  ronnaAI: "RonnaAI",
  findSearchHistory: "Find search history",
  Today: "Today",
  "7 Days": "7 Days",
  "30 Days": "more",
  deleteRecord: "delete record",
  newChat: "New Chat",
  aiTabAnswer: "Answer",
  aiTabCompanies: "Companies",
  aiTabSources: "Sources",
  processingYourRequest: "Processing your request...",
  thinkingDeeply: "Thinking deeply",
  generatingAPlan: "Generating a plan",
  noHistoryYet: "No history yet",

  // advertisement
  targetLocation: "Target Location",
  open_ad: "Open ad",
  ad_type_label: {
    text: "Text creative",
    image: "Image creative",
    video: "Video creative",
    carousel: "Carousel creative",
    other: "Creative",
  },
  est_impressions: "Estimated impressions",
  ads: "Advertisements",

  // expansion signals (Phase 1)
  expansion: {
    pitch: {
      headline: "Pubrio · Find companies expanding into new countries.",
      body: "Thousands of companies enter new markets every day. Be the first call, not the last.",
      dismiss: "Dismiss",
    },
    kpi: {
      title: "Key expansion metrics",
      mostActiveMarket: "Most active market",
      yourFocus: "Your focus",
      companiesInWindow: "{n} with new signals · {window}",
      bestToContact: "Best to contact now",
      inExpandingStage: "in expanding stage",
      movingUnusuallyFast: "Moving unusually fast",
      aheadOfPace: "ahead of typical pace",
      hot: "Hot",
      newActivity: "New activity signals",
      activeMarkets: "Active markets",
      thisWeek: "this week",
      last30Days: "last 30 days",
      movementHeadline: "New activity this period",
      movementHint: "Across {active} of {total} markets",
      // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
      // SELECTED mode reuses tile 1's focus country and drops the chip.
      hintOfMarket: "{rate} of market",
      hintOfFocus: "{rate} of {country} companies",
      hintAheadOfPaceGlobal: "{rate} ahead of pace",
      hintAheadOfPaceFocus: "{rate} of {country} ahead of pace",
      hintNewThisWeekGlobal: "{rate} new this week",
      hintNewThisWeekFocus: "{rate} of {country} new this week",
      // Empty state for SELECTED mode when the picked country has no data
      // in the active date window.
      noDataInWindow: "No signals yet in this window",
    },
    verdict: {
      newMarkets: "New markets",
      momentum: "Momentum",
      expansionScore: "Expansion score",
      vsPrior: "vs prior period",
      noneThisPeriod: "none this period",
      signalsLabel: "Signals",
      scoreVeryStrong: "Very strong",
      scoreStrong: "Strong",
      scoreDeveloping: "Developing",
      scoreEarly: "Early-stage",
    },
    competitive: {
      heading: "Competitive expansion",
      subCurated: "How {name}'s international expansion compares to its competitors",
      comparingAgainst: "Comparing against",
      addCompetitor: "Add competitor",
      gateTitle: "Free plan compares up to {n} competitors",
      gateDesc: "Upgrade to add your own competitors and benchmark the full set.",
      gateDescMore: "Unlock 1 more rival and add your own. | Unlock {n} more rivals and add your own.",
      gateCta: "Upgrade",
      addSearching: "Searching…",
      addEmpty: "No companies found",
      removeCompetitor: "Remove",
      takeawayLead: "{name} leads {n} competitors on {metric}.",
      takeawayRank: "{name} ranks #{rank} of {total} competitors on {metric}.",
      colCompany: "Company",
      colMarket: "Market",
      colActiveMarkets: "Markets",
      colNewMarkets: "New markets",
      colMomentumPct: "Momentum",
      colSignalCount: "Activity",
      colExpansionScore: "Expansion score",
      colWindowExpansionScore: "Recent score",
      colIndustry: "Industry",
      colCountry: "HQ",
      colEmployees: "Employees",
      colFounded: "Founded",
      colWebsite: "Website",
      colTopMarket: "Top expansion",
      colNewestMarket: "Newest entry",
      colScaling: "Scaling",
      colPipeline: "Pipeline",
      colMatch: "Match",
      columns: "Columns",
      columnsHint: "Add fields to your comparison",
      fieldsGroupExpansion: "Expansion metrics",
      fieldsGroupCompany: "Company facts",
      you: "You",
      openCompany: "Open company",
      pendingHint: "Expansion data still loading",
      empty: "No competitors with expansion data yet.",
      cellSignals: "{n} signals",
      hoverHint: "Hover a market metric to see the actual countries behind it.",
      coverageTitle: "Market coverage",
      coverageSub: "Where each rival operates and how deeply — {gaps} of {total} are markets they're in that you're not.",
      covAll: "All",
      covGaps: "Gaps",
      covYours: "Yours",
      watch: "Watch market",
      fieldCaption: "Bars show relative size; the mini-chart is each rival's weekly activity trend.",
      legendStage: "Color = stage",
      legendRecent: "Active recently",
      covYouHint: "Shaded = you",
      coverageCount: "{n} of {total} present",
      cellTypes: "Signal types",
      cellSince: "First seen",
      cellActive: "active {t}",
      sortLabel: "Sort markets",
      covSortCoverage: "Coverage",
      covSortRecent: "Recent",
      searchMarket: "Find a market…",
      noMarkets: "No markets match your filter.",
    },
    dateRange: {
      today: "Today",
      last7: "Last 7 days",
      last30: "Last 30 days",
      last90: "Last 90 days",
      last12m: "Last 12 months",
      customLabel: "Custom range",
      startPlaceholder: "Start",
      endPlaceholder: "End",
    },
    countryChips: {
      title: "Markets",
      subtitle: "Pick one or more markets to focus on — toggle Inbound or Outbound to slice the network",
      ariaLabel: "Followed markets",
      addMarket: "Add market",
      compare: "Compare",
      more: "more",
      remove: "Remove market",
      comparingNMarkets: "Watching {n} market | Watching {n} markets",
      pickMarketsToCompare: "Click markets to compare",
      multiSelectOff: "Multi-select",
      multiSelectOnN: "Multi-select · {n}",
    },
    mapMode: {
      toggleAriaLabel: "Map view mode",
      global: "All markets",
      intoCountry: "Inbound",
      intoCountryHint: "Companies expanding INTO the selected country",
      intoCountryDisabledHint: "Pick a country first to see inbound flow",
      outgoing: "Outbound",
      outgoingHint: "Companies expanding FROM the selected country",
      outgoingDisabledHint: "Pick a country first to see outbound flow",
      backToOverview: "Back to overview",
    },
    find: {
      heading: "What are you hunting?",
      placeholderHero: "Describe a market — e.g. AI companies expanding into Germany",
      placeholderDocked: "Describe a market",
      submit: "Find",
      clear: "Clear",
      hintPrefix: "Try:",
      examples: [
        "Fintech companies expanding into the US",
        "AI companies aggressively expanding into Germany",
        "Companies entering the UK",
        "AI companies expanding into Japan",
        "German companies expanding into France",
        "Companies entering Singapore",
      ],
      noMatch: "Couldn't map that to a filter. Try naming a market, stage, or sector.",
    },
    compare: {
      title: "Compare markets",
      pickMarket: "Pick a market",
      emptyHint: "Add a market to compare",
      totalCompanies: "companies tracked",
      readyToContact: "Ready to contact (Expanding)",
      newThisMonth: "New transitions this month",
      aheadOfPace: "Moving ahead of pace (30d)",
      stageBreakdown: "Stage breakdown",
      expandingShareLabel: "Ready",
      viewMarketAction: "View",
      addColumn: "Add market",
      removeColumn: "Remove this market",
      metricHeader: "Metric",
      winnerBadgeTitle: "Highest among selected markets",
      lensLabel: "Compare by",
      lensVolume: "Total",
      lensShare: "Share %",
      lensShareHint: "Each metric as % of that market's tracked companies",
      insightTitle: "What this tells you",
      insightOverall: "{winner} leads on {n} of {total} metrics overall.",
      insightExpanding: "{winner} has {n} more ready-to-contact companies than {loser} right now.",
      insightMomentumMultiple: "{winner} is acquiring new companies {multiple}× faster than {loser} this month.",
      insightMomentumAbsolute: "{winner} added {n} new companies this month — {loser} added none.",
      insightPace: "{market} has {n} companies moving faster than usual — worth a closer look.",
      insightAboveWeight: "{winner} punches above its weight — {winnerPct} of its market is ready to contact, vs {largerPct} in {larger}.",
      dimExpanding: "Ready-to-contact",
      dimNewThisMonth: "New this month",
      dimAheadOfPace: "Ahead of pace",
      dimTotal: "Total tracked",
      drillCellTitle: "Open {country}",
      drillCellTitleStage: "Open {country} — {stage} stage",
      drillSegTitle: "Open {country} — {stage} ({n} companies)",
      viewCrossMarket: "Search across {n} markets",
      summaryWinner: "{winner} has {n} more ready-to-contact companies than {loser}.",
      summaryTie: "Both markets have the same number of ready-to-contact companies.",
    },
    countryPicker: {
      title: "Add a market",
      searchPlaceholder: "Search country name or code…",
      noMatch: "No country matches your search.",
    },
    stageTiles: {
      title: "Stage distribution",
      subtitle: "Click a stage to filter the list below",
      ariaLabel: "Expansion stages",
      bestToReachOut: "Best time to reach out",
      signalsHeading: "What we look for",
      signalSoon: "soon",
      infoAria: "How this stage is calculated",
    },
    stage: {
      exploring: "Exploring",
      exploringDescription: "Just checking it out",
      committing: "Committing",
      committingDescription: "Putting real resources in",
      expanding: "Expanding",
      expandingDescription: "Growing a local footprint",
      scaling: "Scaling",
      scalingDescription: "Growing an active local presence",
    },
    signal: {
      ad: "Geo-targeted advertising",
      event: "Conference attendance",
      news: "News / PR",
      dns: "Domain / SSL",
      tech: "Product localization",
      infra: "Cloud / infrastructure",
      ip: "Trademark / patent",
      partner: "Partnership",
      eventPlus: "Exhibiting / speaking",
      reg: "Regulatory license",
      entity: "Entity registration",
      exec: "Executive hire",
      office: "Office lease",
      hire: "Local team hiring",
      scale: "Headcount scaling",
      product: "Product launch",
    },
    signalTier: {
      // Premium badge label. Change this word to rebrand the tier (e.g.
      // "Elite"); which signals are premier lives in taxonomy.js.
      premier: "Premier",
    },
    direction: {
      advancing: "Advancing",
      steady: "Steady",
      retreating: "Retreating",
      new: "New",
    },
    freshness: {
      fresh: "Fresh",
      cooling: "Cooling",
      stale: "Stale",
      cold: "Cold",
    },
    filters: {
      title: "Filters",
      clearAll: "Clear all",
      direction: "Direction",
      freshness: "Freshness",
      employees: "Employees",
      industry: "Industry",
      risk: "Risk",
      stage: "Stage",
      scope: "Scope",
      founded: "Founded",
      signalStrength: "Signal strength",
      signalVolume: "Signal volume",
      momentum: "Momentum",
      momentumAccelerating: "Accelerating",
      momentumAdvancing: "Advancing",
      momentumSteady: "Steady",
      momentumPullingBack: "Pulling back",
      stageDesc: "How active a company is in this market — from first signals to scaling up.",
      momentumDesc: "Which way the expansion is trending — accelerating, holding steady, or pulling back.",
      signalVolumeDesc: "How many expansion signals we've detected. More signals means more activity.",
      signalTypeDesc: "The kind of signal — hiring, ads, a new office, news, and more.",
      freshnessDesc: "How recent the latest signal is.",
      scopeDesc: "Entering a brand-new market vs. deepening an existing presence.",
      signalVolumeAny: "Any",
      signalVolumeWord: "signals",
      signalType: "Signal type",
      signalTypeUnavailable: "Coming soon — this signal isn't available yet",
      pace: "Pace",
      onlyAtRisk: "Only at-risk markets",
      onlyAheadOfPace: "Only ahead of pace",
      paceHint: "Companies whose elapsed first-signal → latest transition sits in the country's fastest quartile.",
      // Rail chrome — search, presets, active-row, group headers.
      // Mirrors /search's mature rail structure with /home's revamp visual
      // language. Same component contract will eventually back both pages.
      searchPlaceholder: "Search filters…",
      presets: "Filter presets",
      presetsSavedCount: "{n} saved",
      activeOne: "{n} Active filter",
      activeMany: "{n} Active filters",
      save: "Save",
      clearShort: "Clear",
      groupScope: "Scope",
      groupSignal: "Expansion signal",
      groupSources: "Sources",
      groupCompany: "Company profile",
      date: "Date",
      markets: "To · Target market",
      flowDirection: "Flow direction",
      marketsPlaceholder: "Where they're expanding to (destination)",
      marketsFrom: "From · Home market",
      marketsAny: "Market · any direction",
      marketsFromPlaceholder: "Where they're expanding from (origin)",
      marketsAnyPlaceholder: "Any market they're expanding to or from",
      noMatchingFilters: "No filters match",
      addFilter: "Add filter",
      groupRecent: "Recent",
      groupSuggested: "Suggested",
      savedViews: "Saved filters",
      savedViewsCount: "{n} saved",
      noSavedViews: "No saved filters yet.",
      saveCurrentView: "Save current filter",
      deleteView: "Delete filter",
      deleteConfirm: "Delete",
      cancel: "Cancel",
      confirmDeleteView: "Delete the saved filter “{name}”?",
      saveDialogTitle: "Save filter",
      namePrompt: "Name this filter so you can recall it later.",
      namePlaceholder: "e.g. Hot EU SaaS",
      nameRequired: "Give the filter a name.",
      location: "From · Company HQ",
      locationPlaceholder: "Where they're based (origin)",
      excludeMarkets: "Exclude markets",
      excludeMarketsPlaceholder: "Markets to leave out…",
      excludeOrigins: "Exclude origins",
      excludeOriginsPlaceholder: "Origins to leave out…",
      excludeIndustry: "Exclude industries",
      excludeIndustryPlaceholder: "Industries to leave out…",
      locationHint: "The company's home market. Pair it with a target market to see a From → To corridor (e.g. Singapore → Japan).",
      any: "Any",
      employeesCustomRange: "Custom range",
      predefinedRange: "Predefined range",
      employeesPlaceholder: "Search size range…",
      industrySubCategory: "Sub-industry",
      industryCategory: "Industry categories",
      industrySubCategoryPlaceholder: "Search sub-industry…",
      industryCategoryPlaceholder: "Search industry categories…",
      foundedRange: "Year founded",
      foundedFrom: "From",
      foundedTo: "To",
      min: "Min",
      max: "Max",
      revenue: "Revenue",
      revenueRange: "Annual revenue (USD)",
      revenueMin: "Min ($)",
      revenueMax: "Max ($)",
      revenueHint: "Estimated annual revenue range from enrichment data.",
      specialties: "Specialties",
      specialtiesPlaceholder: "Search a specialty…",
      technologies: "Technologies",
      technologiesPlaceholder: "Search a technology…",
      companies: "Companies",
      companiesPlaceholder: "Search a company…",
      activeTitle: "Active",
      activeEmpty: "No filters active",
      dateChipPrefix: "Date",
      marketChipPrefix: "Market",
      savedListChip: "Saved list",
      savedListFilterNote: "Showing one row per company at their highest reached stage. Stage tiles match the list count.",
      originChipPrefix: "From",
      targetChipPrefix: "Into",
      removeFilter: "Remove {label}",
    },
    scope: {
      enteringNewMarket: "Entering new market",
      expandingWithinPresence: "Expanding within presence",
      establishedOnly: "Established only",
    },
    signalStrength: {
      high: "High confidence",
      medium: "Medium",
      low: "Low",
    },
    row: {
      employees: "employees",
      marketsCount: "{n} markets",
      marketsActiveIn: "Active in {list}",
      founded: "Founded",
      journey: "Journey",
      journeyLabel: "Journey",
      // Three-tier contraction copy, keyed by the contraction_flag value the
      // backend writes (leading | confirming | lagging). Each tier says WHY
      // the banner is on — based on the actual signal that tripped it, not
      // the unrelated "days since last signal" we used to show.
      contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
      contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
      contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
      // Mixed-signal variants (mode_change_flag=true): contraction tripped
      // but recent expansion signals still present. Reads as "watch" not
      // "exit" so a company hiring AND laying off at the same time doesn't
      // get marked as cleanly retreating.
      contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
      contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
      // Generic fallback for older rows written before tier-specific copy
      // shipped. Kept so a missing flag doesn't render a raw template.
      contractionFlag: "This company may be pausing or exiting expansion. See signals below.",
      noSignalsInDays: "No new signals in {days} days. This company may be pausing or exiting expansion.",
      movingFast: "Moving fast",
      movingFastDetail: "{stages} in {months} months.",
      addToSequence: "Add to sequence",
      saveToList: "Save to list",
      viewProfile: "View profile",
      viewSignalsHint: "Click to view all signals",
      signalCount: "{n} signals",
      distinctTypes: "{n} signal types",
      stageUpInDays: "Stage up · {days}d ago",
      stageUpToday: "Stage up · today",
      newInDays: "New · {days}d",
      newToday: "New · today",
      selectRow: "Select company",
      lastSignal: "Last signal",
      stageOf: "Stage {n} of {total}",
      // Hover tooltips — plain-English explanations of internal vocabulary
      // (Retreating, Stale, Stage up, etc.). Native title attribute is used
      // so we don't pay the el-tooltip mount cost on every list row.
      tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
      tooltipDirection_steady: "No stage change in the last 30 days",
      tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
      tooltipDirection_new: "Just appeared as a potential expander",
      tooltipFreshness_fresh: "Last signal in the past 30 days",
      tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
      tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
      tooltipFreshness_cold: "No signals in the past 90 days",
      tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
      tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
      tooltipStageUp: "Recently moved up to the {stage} stage",
      tooltipNew: "First signal detected recently",
      tooltipSignalType: "Signal type: {type}",
    },
    list: {
      // Single stable title shape — filter state lives in the sidebar
      // and the chip row, not in the title text. The legacy 4-variant
      // keys are kept below for backward compatibility; safe to delete
      // in a follow-up.
      title: "{count} companies",
      titleAll: "{count} companies in {country}",
      titleAllGlobal: "{count} companies across all markets",
      titleStageScoped: "{count} companies in {stage} — {country}",
      titleStageScopedGlobal: "{count} companies in {stage} — all markets",
      filteredBy: "Filtered by",
      export: "Export",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {page} of {total}",
      selectAll: "Select all",
      selectAllOption: "All",
      selectThisPage: "This page",
      selectCustomize: "Customize",
      selectHint: "Select up to {count} companies in this view.",
      applySelection: "Apply",
      selected: "{n} selected",
      bulkSequence: "Add to sequence",
      bulkSave: "Save to list",
      bulkExport: "Export selected",
      findPeople: "Find people",
      clearSelection: "Clear",
      paceHint: "Median Exploring → Expanding in {country} is 6 months. {n} companies ahead of pace.",
      movingFast: "Moving fast",
      movingFastDetail: "Exploring → Scaling in 4 months. Median for SaaS in {country} is 6 months.",
      emptyTitle: "No companies match this view yet.",
      emptyBody: "Try a different market or wait for new signals to arrive.",
      emptyStageTitle: "Nobody at this stage right now.",
      emptyStageBody: "Pick another stage to keep exploring.",
      pickCountryTitle: "Pick a country to begin.",
      pickCountryBody: "Click a market chip above (or use the map) to scope the dashboard.",
    },
    map: {
      topSectors: "Top sectors",
      expandingInto: "Expanding into",
      comingFrom: "Coming from",
      placeholderAriaLabel: "Expansion world map",
      loadingBasemap: "Loading basemap…",
      loadingCountry: "Loading market data…",
      loadingDashboard: "Loading expansion data…",
      newThisMonthIn: "New this month in {country}",
      newTransitionsAllMarkets: "New transitions this month",
      readyToContact: "Ready to contact",
      tracked: "Tracked total",
      activeMarkets: "Active markets",
      ctaReadyToContact: "View {n} ready to contact",
      origins: {
        title: "Top origins → {country}",
        total: "{n} cross-border",
        domestic: "+{n} domestic ({country} → {country})",
        untracked: "+{n} origin not yet tracked",
        empty: "Pick a market above to see where companies are expanding from.",
        plusMore: "+{n} more origins",
        clearFilter: "Clear origin filter",
      },
      timeFilterLabel: "Show signals from",
      timeFilterToday: "Today",
      timeFilterWeek: "This week",
      timeFilterMonth: "This month",
      timeFilterAll: "All time",
      activityFeedTitle: "What's new",
      activityFeedEmpty: "No stage transitions in the selected window.",
      activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
      activityFeedFooter: "View all activity →",
      activityFeedAdvanced: "Reached {stage}",
      activityFeedNew: "New signals detected",
      activityFeedFrom: "from {country}",
      activityFeedTitleHint: "Click for company details",
      activityFeedTitleHintCountry: "Click to scope dashboard to this market",
      marketIntelTitle: "Market intel",
      tabOrigins: "Top origins",
      tabWhatsNew: "What's new",
      tabActivity: "Just moved",
      whatsNewAriaLabel: "Market activity insights",
      whatsNewLoading: "Crunching the numbers…",
      whatsNewEmpty: "No transitions in the selected window. Try a wider date range from the map controls.",
      whatsNewMovesLabel: "moves this period",
      whatsNewVsPrev: "vs {n} {label}",
      whatsNewPrevDay: "yesterday",
      whatsNewPrevWeek: "last week",
      whatsNewPrevMonth: "last month",
      whatsNewPrevDays: "previous {n} days",
      whatsNewHotCorridors: "Hot corridors",
      whatsNewSurgingDestinations: "Surging destinations",
      whatsNewSurgingOrigins: "Surging origins",
      whatsNewStageVelocity: "Stage velocity",
      whatsNewNotableMovers: "Notable movers",
      whatsNewDeltaNew: "NEW",
      whatsNewDeltaFlat: "Flat",
      whatsNewCorridorHint: "Filter list to {from} → {to}",
      whatsNewDestinationHint: "Focus dashboard on {country}",
      whatsNewOriginHint: "Filter list to companies from {country}",
      whatsNewStageHint: "Filter list to {stage} stage",
      whatsNewScopeGlobal: "All markets",
      whatsNewScopeMulti: "{n} markets",
      whatsNewWindowToday: "today",
      whatsNewWindowWeek: "past 7 days",
      whatsNewWindowMonth: "past 30 days",
      whatsNewWindowDays: "past {n} days",
      whatsNewViewAll: "View all companies in list",
      whatsNewViewAllN: "View all {n} companies",
      whatsNewWhereFrom: "Where they're from",
      whatsNewPipelineMix: "Pipeline mix",
      whatsNewCaptionGlobal: "Moves across all markets · {window}",
      whatsNewCaptionCountry: "Moves into {country} · {window}",
      whatsNewCaptionMulti: "Moves across {n} markets · {window}",
      whatsNewTabForYou: "For you",
      whatsNewTabFastMovers: "Fast movers",
      whatsNewTabWideExpanders: "Wide expanders",
      whatsNewWideExplainer: "Companies that just entered 3+ new markets — aggressive multi-country push.",
      whatsNewWideEmptyTitle: "No wide expanders in this view",
      whatsNewWideEmptyBody: "Try widening the date range or clearing country filters to see companies hitting many markets at once.",
      whatsNewMarketsCount: "{n} new markets",
      whatsNewMarketsInlineMore: "+{n} more",
      whatsNewFoundedYear: "Founded {year}",
      whatsNewOpenList: "Open list: {name}",
      whatsNewForYouExplainer: "Your saved company lists with members that moved in this window.",
      whatsNewForYouEmptyTitle: "No new movement in your lists",
      whatsNewForYouEmptyBody: "None of your saved companies had stage transitions in this window. Widen the date range or check back later.",
      whatsNewUnnamedList: "Untitled list",
      whatsNewListCount: "{n} companies",
      whatsNewListUpdated: "Updated {time}",
      whatsNewSavedListMovers: "{count} new mover | {count} new movers",
      whatsNewSavedListMoversAriaLabel: "{count} new movers in this list",
      whatsNewSavedListTotal: "{total} saved",
      whatsNewFastMoversTitle: "Moving ahead of pace",
      whatsNewFastEmptyTitle: "No fast movers in this view",
      whatsNewFastEmptyBody: "Try widening the date range or clearing the country filter to see companies moving ahead of pace.",
      whatsNewFastExplainer: "Companies moving faster than 75% of peers in their market.",
      whatsNewMovingFastDetail: "{from} → {to} in {months} mo",
      whatsNewStageUpAt: "Stage up · {time}",
      whatsNewViewList: "View full company list",
      whatsNewMarketsChip: "Entered {n}+ markets",
      whatsNewVerbInto: "expanding into {scope}",
      whatsNewVerbAcross: "cross-border moves tracked",
      whatsNewVelocityTitle: "{n} companies {verb} this period",
      whatsNewVelocityDetail: "up from {previous} in the {window} before",
      whatsNewVelocityDetailNoPrior: "first period with meaningful activity",
      whatsNewStoryNew: "{from} → {to} corridor is new this period",
      whatsNewStoryNewDetail: "{n} companies just made the move — first time we've tracked any",
      whatsNewStorySurge: "{from} → {to} surged {delta}%",
      whatsNewStoryCool: "{from} → {to} cooled {delta}%",
      whatsNewStoryDeltaDetail: "{current} moves this period vs {previous} the period before",
      whatsNewStoryStageUp: "{stage} stage transitions up {delta}%",
      whatsNewStoryStageDown: "{stage} stage transitions down {delta}%",
      whatsNewStoryStageDetail: "{n} companies just reached {stage}",
      whatsNewStoryMover: "{company} just reached {stage}",
      showActivity: "Show market intel",
      hideActivity: "Hide market intel",
      windowEmptyBody: "Widen the date range to surface this company's activity.",
      noActivityTitle: "No movement yet in this view.",
      noActivityBody: "Pick another market or switch to global flows.",
      noOutgoingTitle: "No outgoing signals from {country} yet",
      noOutgoingBody: "We haven't detected any companies expanding OUT of {country} in the current data. Try switching to the Selected market view to see who's expanding INTO this country instead.",
      noOutgoingCta: "View companies expanding into this market",
      companiesCount: "{n} company | {n} companies",
      newThisMonthCount: "{n} new this month",
      collapseCard: "Minimize",
      expandCard: "Expand",
      clickHint: "Hover a market for details · click to drill in",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      resetView: "Reset view",
      densityShowN: "Up to {n} market | Up to {n} markets",
      densitySliderAriaLabel: "Map density — slide to show more or fewer origins",
      legendAriaLabel: "Map legend",
      legendTitle: "Stages",
      legendSectionRecent: "Recent activity",
      legendStageUp: "Advancing",
      legendStageUpTitle: "Cyan ring marks countries that advanced a stage in the last 30 days",
      legendNew: "New",
      legendNewTitle: "Glowing dot marks countries where expansion started in the last 90 days",
      legendBadge30d: "30 days",
      legendBadge90d: "90 days",
      legendCollapse: "Minimise legend",
      legendExpand: "Show legend",
      companies: "companies",
    },
    tooltip: {
      signals: "signals",
      companiesMoving: "companies moving",
      companiesExpandingFrom: "companies expanding from here",
      companiesArrivingAt: "companies arriving from this origin",
      clickToScope: "Click to filter the list →",
    },
    popover: {
      close: "Close",
      loading: "Loading details…",
      loadFailed: "Couldn't load this market.",
      keyMoments: "Key moments",
      signals: "Signals ({n})",
      firstSignal: "First signal",
      latestSignal: "Latest signal",
      reachedStage: "Reached {stage}",
      stageUp: "Stage up",
    },
    // Unified evidence dashboard tab bar (ExpansionDashboard.vue).
    // Hiring-intelligence band on the company-detail Hiring tab (JobsInsights.vue).
    jobsInsights: {
      heading: "Hiring activity",
      windowReadout: "Last {n} days",
      windowHint: "Counts cover postings active in this window",
      kpiOpen: "Open roles",
      kpiPosted: "Roles posted",
      openSub: "{n} open all-time",
      kpiPace: "Hiring pace",
      kpiTopFunction: "Top function",
      kpiMarkets: "Markets",
      newSub: "+{n} new",
      trendVsPrior: "vs prior",
      marketShare: "{pct}% {place}",
      nRoles: "{n} role | {n} roles",
      momentumLabel: "Hiring momentum",
      velAccel: "Accelerating",
      velSlow: "Slowing",
      velSteady: "Steady",
      mover: "{flag} {place} — {n} roles in the past month",
      moverSenior: "{flag} {place} — {n} roles in the past month, mostly {tier}",
      moverNew: "· new market",
      exploreLabel: "Explore",
      exploreHint: "Tap a bar — see how role, market & seniority connect",
      showingOf: "{n} of {total} roles",
      clearAll: "Clear",
      listFilteredBy: "Filtered by",
      notClassified: "{n} not classified",
      openListTitle: "Roles posted",
      openListNote: "Posted · {window}",
      leadTopFunction: "{label} leads here — {count} roles",
      leadTopLocation: "{pct}% in {place}",
      tier_executive: "Exec",
      tier_director: "Director",
      tier_manager: "Manager",
      tier_senior: "Senior",
      tier_junior: "Junior",
      byFunction: "By function",
      byLocation: "By location",
      bySeniority: "By seniority",
      thisCompany: "This company",
      narrFast: "{company} is scaling fast — {n} roles opened in the last {days} days, up {pct}% vs the prior period.",
      narrUp: "{company} is actively hiring — {n} new roles in the last {days} days, up {pct}% vs prior.",
      narrSteady: "{company} is hiring steadily — {n} roles in the last {days} days, level with the prior period.",
      narrDown: "{company} is easing off hiring — {n} roles in the last {days} days, down {pct}% vs prior.",
      narrQuiet: "{company} has {open} open roles, with little new posting activity lately.",
      narrMix: "{fn}-led and concentrated in {loc}.",
      narrMixSenior: "{fn}-led and concentrated in {loc}, with {pct}% in leadership roles.",
      loadError: "Couldn't load hiring insights",
      retry: "Retry",
      none: "—",
    },
    // Advertising-intelligence band (AdsInsights.vue).
    adsInsights: {
      eyebrow: "Ad activity",
      openListTitle: "Active ads",
      lead: "{n} active campaign across {markets} markets | {n} active campaigns across {markets} markets",
      kpiActive: "Active campaigns",
      kpiMarkets: "Markets targeted",
      kpiTopChannel: "Top channel",
      kpiTopFormat: "Top format",
      leadReach: "reaching up to {reach}",
      kpiMomentum: "Momentum",
      windowSub: "last {n} days",
      trendVsPrior: "vs prior",
      sparkLabel: "Campaign launches",
      moreInsights: "More insights",
      lessInsights: "Hide insights",
      byReach: "By reach (impressions)",
      reach_lt_1k: "< 1K",
      reach_1k_10k: "1K–10K",
      reach_10k_50k: "10K–50K",
      reach_50k_100k: "50K–100K",
      reach_100k_500k: "100K–500K",
      reach_500k_1m: "500K–1M",
      reach_1m_plus: "1M+",
      reachPeak: "peak {peak}",
      byMarket: "By target market",
      byChannel: "By channel",
      byFormat: "By format",
      byPlacement: "By placement",
      exploreLabel: "Explore",
      exploreHint: "Tap a bar — see how reach, markets & channels connect",
      exploringOf: "Exploring {n} of {total} most recent",
      showingOf: "{n} of {total} ads",
      clearAll: "Clear",
      leadTopMarket: "{pct}% target {place}",
      leadTopChannel: "{pct}% run on {channel}",
      noImpression: "No impression data for these ads",
      noImpressionN: "{n} without impression data",
      noMarket: "No target-market data",
      noMarketN: "{n} without a target market",
      marketLed: "led by {place}",
      creatives: "Recent creatives",
      detail: {
        status: "Status",
        ran: "Ran",
        reach: "Reach",
        channel: "Channel",
        format: "Format",
        markets: "Markets",
        placements: "Placements",
        noPreview: "No image preview",
        visit: "Visit landing page",
        moreMarkets: "+{n} more",
      },
      nCampaigns: "{n} campaign | {n} campaigns",
      loadError: "Couldn't load ad insights",
      retry: "Retry",
      none: "—",
    },
    // Media & deal-signal band (NewsInsights.vue).
    newsInsights: {
      eyebrow: "Media coverage",
      lead: "{n} mention in the last {days} days | {n} mentions in the last {days} days",
      kpiMentions: "Mentions",
      kpiMomentum: "Momentum",
      kpiPositive: "Expansion signals",
      kpiRisk: "Risk signals",
      kpiTopics: "Topics",
      kpiSources: "Sources",
      ledBy: "Led by {x}",
      windowSub: "last {n} days",
      trendVsPrior: "vs prior",
      sparkLabel: "Coverage volume",
      fundingLatest: "Latest round",
      moreInsights: "More insights",
      lessInsights: "Hide insights",
      byTopic: "By topic",
      byMarket: "By market",
      openListTitle: "Recent news",
      exploreHint: "Tap a topic to filter the list",
      loadError: "Couldn't load media insights",
      retry: "Retry",
      none: "—",
    },
    dashboard: {
      tabExpansion: "Expansion intelligence",
      tabComparison: "Comparison",
      tabHiring: "Hiring",
      tabTech: "Tech stack",
      tabAds: "Ads",
      tabNews: "News",
      tabContacts: "Employees",
      keyContacts: "Key contacts",
    },
    // Expansion section on the company-detail page (ExpansionSummary.vue).
    summary: {
      heading: "Global expansion",
      subheading: "Where this company operates and the markets it's moving into.",
      subheadingCount: "Across {n} markets worldwide — where it started, and where it's growing now.",
      founded: "Founded",
      employees: "employees",
      markets: "Markets",
      marketsHintFrom: "Expanding from {hq}",
      marketsHintWorldwide: "Worldwide presence",
      furthestStage: "Furthest stage",
      movingNow: "Moving now",
      movingNowHint: "Advanced in the last 90 days",
      upToMarkets: "Up to {n} markets",
      stages: "Stages",
      loading: "Loading expansion…",
      empty: "No expansion signals tracked for this company yet.",
      // Enriched no-data / load-error states (the map + feed surface).
      emptyTitle: "Listening for expansion signals",
      emptyDetail: "Nothing to show yet. As {company} hires, makes news, and runs ads in new markets, the signals will surface here.",
      emptyMore: "+{n} more",
      thisCompany: "this company",
      established: "Established",
      establishedTip: "Operates across these markets — no new expansion activity",
      establishedNote: "{company} is established across {n} markets — no new expansion activity in this window.",
      errorTitle: "Couldn't reach the signal service",
      errorDetail: "We couldn't load expansion data just now. This is usually temporary — give it another try.",
      retry: "Retry",
      // Command-bar button hover tooltips — every control gets a consistent hint.
      tipMarket: "Filter by market",
      tipDate: "Change the time range",
      tipStage: "Filter by lifecycle stage",
      tipExport: "Export this company",
      tipClear: "Clear all filters",
      // Insight line under the "Global expansion" heading.
      insight: "Across {total} markets · first moved into {market} in {year} · {moving} advanced in the last 90 days",
      insightNoFirst: "Across {total} markets · {moving} advanced in the last 90 days",
      // Time-scope segmented control.
      timeAll: "All time",
      time12m: "12M",
      time6m: "6M",
      time3m: "3M",
      // Market-focus filter — narrows the map + entry timeline to chosen markets.
      filterFocus: "Focus markets",
      filterAll: "All markets",
      filterMore: "+{n} more",
      filterClear: "Clear",
      filterShowing: "{n} of {total} markets",
    },
    // Activity pulse — "what they're doing now" across all markets (ActivityPulse.vue).
    pulse: {
      heading: "Activity pulse",
      windowHint: "Window follows the date filter above",
      catHiring: "Hiring",
      catMarketing: "Marketing & PR",
      catProduct: "Product & Tech",
      catFootprint: "Footprint",
      catPartners: "Partnerships",
      leadMore: "{type} +{n}",
      leadNone: "No activity",
      trendNew: "New",
      trendSteady: "Steady",
      trendEnded: "Ended",
      recentEvents: "Recent events",
      headcountReduction: "Headcount reduction",
      postingCount: "{n} postings with this title",
      loadMore: "Load more",
      loadingMore: "Loading…",
      viewSource: "View source",
      via: "via {source}",
      sourceNews: "News",
      sourceJobs: "Jobs",
      sourceAds: "Ads",
      focusMarket: "Focus {market} in the feed",
      drillSub: "{n} signals · {types} types active",
      hQuiet: "Quiet across all markets — no signals in this window.",
      hNew: "New {category} activity — {n} fresh signals just appeared.",
      hRising: "{category} is accelerating — up {pct}% vs the prior period.",
      hTop: "Most active in {category} — led by {type} ({n} signals).",
      hTopPlain: "Most active in {category} — {n} signals.",
    },
    // Stage-distribution bar on the company-detail page (ExpansionPortfolioBar.vue).
    portfolio: {
      heading: "Expansion portfolio",
      markets: "markets",
    },
    // Per-market journey list on the company-detail page (MarketTimeline.vue).
    timeline: {
      heading: "Market entry timeline",
      subEntry: "The order this company entered each market — oldest to newest",
      subMomentum: "Markets ranked by most recent stage momentum",
      byEntry: "By entry",
      byMomentum: "By momentum",
      signals: "signals",
      signalTypes: "signal types",
      stageUp: "Stage up · {when}",
      stageUpToday: "Stage up · today",
      now: "now",
      firstSignal: "First signal detected",
      longEstablished: "Long-established",
      ordinalEntered: "{ord} market entered",
      trackedDays: "{n}d tracked",
      trackedMonths: "{n}mo tracked",
      trackedYears: "{n}y tracked",
      confidence: "{n}% confidence",
      empty: "No markets match this filter.",
      showAll: "Show all {n}",
      showLess: "Show less",
    },
    // Per-market signal feed on the company-detail page (SignalFeed.vue).
    feed: {
      signalsIn: "Signals in",
      signals: "signals",
      via: "via {source}",
      reached: "Reached {stage}",
      firstSignal: "First signal",
      show: "Show {n}",
      hide: "Hide",
      empty: "No signals detected in this market yet.",
      emptyHint: "Pick another market on the map, or widen the time range to surface more activity.",
      // No market chosen yet — invite a pick (vs. filters that cleared every market).
      pickTitle: "Select a market",
      pickHint: "Pick any market on the timeline to explore its signals.",
      noMarketsTitle: "No markets in view",
      noMarketsHint: "Adjust your filters to bring markets back.",
      loadMore: "Load more signals",
    },
    // Per-market detail panel on the company-detail page (MarketDetail.vue).
    marketDetail: {
      currentStage: "Current stage",
      confidence: "Confidence",
      pace: "Pace",
      recentSignals: "Recent signals",
      signalsMeta: "{count} signals · latest {when}",
      noDetail: "No detail available for this market.",
      close: "Close",
      high: "High",
      medium: "Medium",
      low: "Low",
      fast: "Fast",
      typical: "Typical",
      slow: "Slow",
      unitDay: "d",
      unitMonth: "mo",
      unitYear: "yr",
    },
    // Labeled fact grid in the company-detail hero (company-detail.vue).
    companyFacts: {
      hq: "HQ",
      industry: "Industry",
      employees: "Employees",
      founded: "Founded",
      type: "Type",
      ranking: "Ranking",
      ticker: "Ticker",
      duplicateProfileNotice: "This is a duplicate profile.",
      viewCurrentProfile: "View current profile",
      duplicateProfileTip: "This profile is a duplicate — open the current one",
      revenue: "Revenue",
      yearsActive: "{n} yrs active",
      // HQ hover → office footprint panel (grouped by country, HQ pinned).
      footprint: {
        title: "Global footprint",
        offices: "office | offices",
        countries: "country | countries",
        hq: "HQ",
        countOffices: "{n} offices",
        other: "Other",
        copy: "Copy address",
      },
    },
    // Markets "first / now" rail on the company-detail page (JourneyRail.vue).
    journey: {
      wentFirst: "Entered first",
      wentFirstSub: "In the order they expanded",
      movingNow: "Moving now",
      movingNowSub: "Most recent stage momentum",
      none: "No expansion markets yet",
      showAll: "Show all {n}",
      showLess: "Show less",
    },
    drawer: {
      title: "Company expansion profile",
      currentStage: "Current stage",
      confidence: "Confidence",
      confidenceHigh: "High",
      confidenceMedium: "Medium",
      confidenceLow: "Low",
      signalGeneric: "Signal",
      allSignals: "Signal timeline",
      signalsCount: "{n} signals",
      // "X of Y signals" when paginated and there's more to load.
      signalsCountOf: "{n} of {total} signals",
      // Pill-button under the timeline. Matches jobs/search pagination.
      loadMore: "Load more signals",
      // Picker on the EXPANSION TO header — used as aria-label + popover title.
      switchMarket: "Switch market",
      // Duration labels on the journey rail — sit between two reached
      // stages and answer "how fast did they move?" ("3w" between
      // Committing and Expanding). Singular forms reserved for n=1.
      durationDays: "{n}d",
      durationWeeks: "{n}w",
      durationMonths: "{n}mo",
      durationYears: "{n}y",
      // Narrative line under the journey rail.
      // "Reached Expanding 1d ago" — when the company entered the current stage.
      reachedStageAt: "Reached {stage} {when}",
      // "3w in Committing" — how long they spent in the previous stage.
      transitionDuration: "{duration} in {prev}",
      noSignals: "No detail signals captured yet for this market pair.",
      contractionBanner: "Contraction signals detected — verify this company is still expanding before reaching out.",
      openFullProfile: "Open full profile",
      visitWebsite: "Visit website",
      // Expansion context (route between hero card and stage strip)
      expandingInto: "Expanding into",
      expandingFrom: "from",
      expansionTo: "Expansion to",
      signalsInMarket: "Signals in",
      signalGroupTitle: "{n} × {type}",
      signalGroupContext: "{items}",
      // Reworded display for SCALE-type "headcount_scaling" signals.
      // Default backend label "165 active postings" reads like an event
      // count next to HIRE event rows; this framing makes the snapshot
      // semantic explicit ("currently open" = right now, not an event).
      headcountScalingTitle: "{n} jobs currently open",
      // Per-type chip below the activity heatmap — 12-week count by signal
      // type. Same window as the heatmap so chip total = sum of bars above.
      recentSignalsChip: "{n} {type} · 12w",
      // Activity heatmap above the signals timeline.
      activityLabel: "Activity",
      activityWindow: "{weeks} weeks",
      activityTotal: "All",
      activityFilterByType: "Filter timeline to {type}",
      activityCellTooltip: "{n} × {type} · {week}",
      activityCellMore: "+{n} more",
      activityCellEmpty: "No {type} signals · {week}",
      activityEmpty: "Quiet for now",
      activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
      // Snapshot stats strip — SCALE-type signals above the timeline.
      snapshotLabel: "Current snapshot",
      showItems: "Show {n}",
      // Group expansion when not all items in the group are loaded yet
      // (the rest arrive when user clicks the page-level "Load more").
      showItemsOf: "Show {n} of {total}",
      hideItems: "Hide",
      loadingMore: "Loading…",
      // Company overview tile
      companyAtAGlance: "Company at a glance",
      industry: "Industry",
      founded: "Founded",
      employees: "Employees",
      headquarters: "Headquarters",
      website: "Website",
      // Presence section
      onTheGround: "On the ground",
      presenceOffice: "Office",
      presenceLegal: "Legal entity",
      presenceHiring: "Hiring",
      // Milestone — SCALE-class threshold marker, rendered inline with timeline entries.
      milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
      milestoneScale: "Open roles reached scale",
      // Other markets
      alsoExpandingTo: "Also expanding to",
      noOtherMarkets: "No other markets detected yet.",
      showAll: "Show all ({n})",
      showLess: "Show less",
      filterAll: "All",
      // Pace
      paceLabel: "Expansion pace",
      paceText: "{days} days from first signal to {stage}",
      paceFast: "Fast",
      paceTypical: "Typical",
      paceSlow: "Slow",
      // In-market team — local presence read for "already there vs. really going".
      localTeamLabel: "Team here",
      lastActiveLabel: "Last active",
      teamPeople: "people",
      localTeamNone: "None",
      localTeamNetNew: "Net-new",
      localTeamEmerging: "Emerging",
      localTeamEstablished: "Established",
      localTeamNoData: "—",
      localTeamNoDataMeta: "No local data",
      // Presence-aware read — reconciles an entry-framed stage with an existing local team.
      localTeamOnSite: "On site",
      readScalingTitle: "Scaling an existing team",
      readScalingDetail: "Already established in {market} — recent hiring and ads grow an in-market operation, not a new entry.",
      readDeepeningTitle: "Deepening its presence",
      readDeepeningDetail: "Established in {market} and actively adding more — expanding an existing operation, not a first entry.",
      readSteadyTitle: "Active in-market",
      readSteadyDetail: "Established in {market} with steady, ongoing local activity.",
      readEstablishingTitle: "Establishing a presence",
      readEstablishingDetail: "A small team is already in {market} — recent signals point to scaling it up.",
      paceInMarket: "In-market",
      thisMarket: "this market",
      readAxesFootnote: "Stage tracks recent activity · Team tracks size — the two can differ.",
      teamFoundDetail: "{n} people found in {market} — likely more.",
      // Signal labels
      signalSource: "via {source}",
      signalTierHint: "Hard-to-source intelligence, surfaced by Pubrio",
      signalSourceFrom: "via {source} · {host}",
      signalViewSource: "View source",
      signalNoEvidence: "No source link available",
      // Footer note
      poweredBy: "Last detected signal",
    },
    live: {
      title: "Market Updates",
      live: "Live",
      all: "All",
      advancing: "Advancing",
      retreating: "Retreating",
      tabNews: "News",
      tabFunding: "Funding insights",
      tabJobs: "Job postings",
      tabAds: "Ads",
      sort: "Sort",
      sortNewest: "Newest first",
      sortOldest: "Oldest first",
      sortImpact: "Impact",
      filter: "Filter",
      findPeople: "Find people",
      searchPlaceholder: "Search …",
      pendingBanner: "{n} new articles since your last visit · click to load",
      empty: "No transitions yet — they'll appear here as companies move.",
      lastHour: "Last hour",
      advanced: "advanced to",
      retreated: "retreated from",
      decayed: "decayed from",
      changed: "transitioned to",
    },
    trending: {
      title: "Trending Companies",
      mostActiveToday: "Most active today",
      catAll: "All",
      catTechnology: "Technology",
      catFintech: "Fintech",
      catHealthcare: "Healthcare",
      catSaaS: "SaaS",
      more: "more",
      empty: "No trending companies yet.",
    },
    toast: {
      sequenceQueued: "Add to sequence opened — pick a sequence from the popup.",
      savedToList: "Saved {name} to your list.",
      saveFailed: "Couldn't save to list. Try again.",
      exportReady: "Exported {n} rows.",
      exportFailed: "Export failed — try a smaller batch.",
    },
    export: {
      title: "Export expansion to CSV",
      // Singular/plural via $tc — used with `count` interpolation.
      body: "Exporting {count} row to CSV will use {price} credit. | Exporting {count} rows to CSV will use {price} credits.",
    },
    // "Watch this view" — turns the current market + filter scope into a
    // monitor, shown openly in the command bar with live status.
    watch: {
      cta: "Watch this view",
      ctaShort: "Watch",
      watching: "Watching",
      newCount: "{n} new",
      cadenceHeading: "Alert me",
      start: "Start watching",
      recommended: "Recommended",
      update: "Update monitor",
      // Cadence options (mapped to monitor frequency minutes).
      realtime: "Real-time",
      realtimeDesc: "As each signal lands",
      daily: "Daily digest",
      dailyDesc: "One summary each day",
      weekly: "Weekly digest",
      weeklyDesc: "One summary on Mondays",
      // Status popover.
      statusActive: "Active",
      statusPaused: "Paused",
      newMatches: "New matches",
      lastChecked: "Last checked",
      never: "Not yet run",
      frequency: "Frequency",
      scope: "Scope",
      scopeSummary: "{market} · {n} filters",
      allMarkets: "All markets",
      viewMatches: "View matches",
      pause: "Pause",
      resume: "Resume",
      stop: "Stop watching",
      namePlaceholder: "Name this monitor",
      defaultName: "{market} · Expansion signals",
      monitorName: "{market} · Expansion signals #{date}",
      created: "Watching — you'll be alerted to new signals",
      updated: "Monitor updated",
      stopped: "Stopped watching",
      paused: "Monitor paused",
      resumed: "Monitor resumed",
      // Shown when filters change after a monitor was created for this view.
      viewChanged: "Filters changed — update your monitor to match",
      empty: "Add a market or filter to watch this view",
    },
    widgetRail: {
      title: "More widgets",
      expandHint: "Click to expand",
    },
    errors: {
      loadFailed: "Couldn't load expansion data.",
      retry: "Try again",
    },
    time: {
      unknown: "—",
      today: "today",
      daysAgo: "{n}d ago",
      weeksAgo: "{n}w ago",
      monthsAgo: "{n}mo ago",
      yearsAgo: "{n}y ago",
    },
  },
};
